import { translations } from "./translations";

const SENT_KEY = "contactFormSent";

function getLang() {
  return localStorage.getItem("language") || "ro";
}

function formText(key) {
  const lang = getLang();
  return (
    translations[lang]?.contact?.form?.[key] ||
    translations.en.contact.form[key]
  );
}

function clearForm(form) {
  form.reset();
  form.querySelectorAll("input, textarea").forEach((field) => {
    if (field.type !== "hidden" && field.name !== "_gotcha") {
      field.value = "";
    }
  });
}

function initContactForm() {
  const form = document.querySelector(".contact-form");
  if (!form) return;

  const submitButton = form.querySelector('button[type="submit"]');

  const clearIfSent = () => {
    if (sessionStorage.getItem(SENT_KEY) === "1") {
      clearForm(form);
      sessionStorage.removeItem(SENT_KEY);
    }
  };

  clearIfSent();
  window.addEventListener("pageshow", clearIfSent);

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    submitButton.disabled = true;
    submitButton.textContent = formText("sending");

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok || data.error) {
        throw new Error(data.error || formText("error"));
      }

      sessionStorage.setItem(SENT_KEY, "1");
      clearForm(form);
      alert(formText("success"));
    } catch (error) {
      alert(error.message || formText("error"));
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = formText("submit");
    }
  });
}

initContactForm();
